import React, { useEffect } from 'react';
import { useMatch } from 'react-router-dom';
import { RouteContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
function RouteChildren(props) {
    const rawRoute = props.context.get();
    const normalizedRoute = rawRoute.replace('/*', '');
    const match = useMatch(normalizedRoute);
    useEffect(() => {
        if (match) {
            HistoryService.setMatch(match);
        }
    }, [props.route, match]);
    return (React.createElement(RouteContext.Context.Provider, { value: props.context }, props.children));
}
export { RouteChildren, };
//# sourceMappingURL=route-children.js.map